<ion-app>
  @if (isServerStatusDown == false) {
    <ion-router-outlet></ion-router-outlet>
  } @else {
    <div class="text__center status-main-container">
      <img src="../../../assets/imgs/logo.png" /><br>
      <img src="../../../assets/imgs/status-loader.gif" /><br>
      <ion-button size="small"(click)="this.checkServerStatus()">{{'riprovaLabel' | tr}}</ion-button><br>
    </div>
  }
</ion-app>